module.exports = __webpack_public_path__ + "static/media/water.0be91391.svg";